export type setFieldValue = (field: string, value: any, shouldValidate?: boolean) => void;

export enum CurrentDialogEnum {
  None = '',
  AddProperty = 'addProperty',
  AccountProfile = 'accountProfile',
  Privacy = 'privacy',

  Notifications = 'notifications',
  InviteFriends = 'inviteFriends',
}
